import React from "react";

const publicPath = process.env.PUBLIC_URL || "";

function PrivacyPolicy() {
  return (
    <div className="privacy-layout">
      <div className="privacy-top">
        <div className="rail-stack privacy-rail-stack" aria-hidden="true">
          <span className="rail rail-cyan" />
          <span className="rail rail-magenta" />
          <span className="rail rail-yellow" />
        </div>

        <header
          className="site-header site-header-visible site-header-static"
          style={{
            "--header-base": "#f5f5f5",
            "--header-next": "#f5f5f5",
          }}
        >
          <span className="site-header-overlay" aria-hidden="true" />
          <a className="header-brand" href={`${publicPath}/#cogi`}>
            COGI
          </a>
        </header>

        <main className="privacy-page">
          <section className="privacy-page-content">
            <div className="privacy-shell">
              <h1>Privacy Policy</h1>

              <section className="privacy-section">
                <p>Last time changed: 2026-03-16</p>
              </section>

              <section className="privacy-section">
                <h2>Information You Provide</h2>
                <p>
                  If you contact us, you may provide your name, email address, and message content.
                </p>
              </section>

              <section className="privacy-section">
                <h2>How It Is Used</h2>
                <p>
                  We use submitted information only to review your inquiry and respond to you.
                </p>
              </section>

              <section className="privacy-section">
                <h2>Contact</h2>
                <p>If you have questions, contact us at info@cogi.lt</p>
              </section>
            </div>
          </section>
        </main>
      </div>

      <footer className="site-footer">
        <div className="footer-content">
          <p className="footer-phrase">
            <span className="footer-phrase-cyan">colon</span>{", "}
            <span className="footer-phrase-magenta">caret</span>{", "}
            <span className="footer-phrase-yellow">right parenthesis</span>{"."}
          </p>
          <p className="footer-meta">
            &copy; 2026 MB Cogi. All rights reserved.{" "}
            <a className="footer-privacy-button" href={`${publicPath}/privacy-policy`}>
              Privacy policy
            </a>
          </p>
        </div>
        <div className="rail-stack rail-stack-footer" aria-hidden="true">
          <span className="rail rail-transparent" />
          <span className="rail rail-transparent" />
          <span className="rail rail-transparent" />
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
